/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpsertSettingsRequestBody,
  UpsertSettingsRequestBody$Outbound,
  UpsertSettingsRequestBody$outboundSchema,
} from "../components/upsertsettingsrequestbody.js";

export type UpsertSkillEfficacySettingsSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type UpsertSkillEfficacySettingsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  upsertSettingsRequestBody: UpsertSettingsRequestBody;
};

/** @internal */
export type UpsertSkillEfficacySettingsSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpsertSkillEfficacySettingsSecurity$outboundSchema: z.ZodMiniType<
  UpsertSkillEfficacySettingsSecurity$Outbound,
  UpsertSkillEfficacySettingsSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function upsertSkillEfficacySettingsSecurityToJSON(
  upsertSkillEfficacySettingsSecurity: UpsertSkillEfficacySettingsSecurity,
): string {
  return JSON.stringify(
    UpsertSkillEfficacySettingsSecurity$outboundSchema.parse(
      upsertSkillEfficacySettingsSecurity,
    ),
  );
}

/** @internal */
export type UpsertSkillEfficacySettingsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  UpsertSettingsRequestBody: UpsertSettingsRequestBody$Outbound;
};

/** @internal */
export const UpsertSkillEfficacySettingsRequest$outboundSchema: z.ZodMiniType<
  UpsertSkillEfficacySettingsRequest$Outbound,
  UpsertSkillEfficacySettingsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    upsertSettingsRequestBody: UpsertSettingsRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      upsertSettingsRequestBody: "UpsertSettingsRequestBody",
    });
  }),
);

export function upsertSkillEfficacySettingsRequestToJSON(
  upsertSkillEfficacySettingsRequest: UpsertSkillEfficacySettingsRequest,
): string {
  return JSON.stringify(
    UpsertSkillEfficacySettingsRequest$outboundSchema.parse(
      upsertSkillEfficacySettingsRequest,
    ),
  );
}
